<template>
  <!-- FILTER START -->
  <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
          <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="row outerBox filterBox">
          <div class="col row">

            <!-- DEALER/MAIN DEALER FILTER START -->
            <div v-if="config.dealerExist" class="col-md-12">
              <div class="row">
                <div class="col-md-3" v-if="!config.dealerTypeExist">
                  <label>Dealer Type</label>
                  <div class="onoffswitch" style="margin-top:10px">
                    <input type="checkbox" v-model="dealerType" class="onoffswitch-checkbox" id="myonoffswitch">
                    <label class="onoffswitch-label" for="myonoffswitch">
                      <span class="onoffswitch-inner"></span>
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
    
                <!-- Main Dealer Start -->
                <div v-if="dealerType" :class="{ 'mobileFilterPaddingTop' : mobile, 'col-md' : !config.dealerTypeExist, 'col-md-6' : config.dealerTypeExist }">
                    <label>Main Dealer</label>
                    <MultiSelect 
                      v-if="filterOptions"
                      v-model="filter.mainDealer"
                      class="mt-1"
                      :options="filterOptions.mainDealer"
                      label="name"
                      track-by="code"
                      :multiple="true"
                      placeholder="All Main Dealer"
                    ></MultiSelect>
                </div>
                <div v-if="dealerType" :class="{ 'mobileFilterPaddingTop' : mobile, 'col-md' : !config.dealerTypeExist, 'col-md-6' : config.dealerTypeExist }">
                    <label for="partshopCode">Gudang</label>
                    <MultiSelect 
                      v-if="filterOptions"
                      v-model="filter.gudang"
                      class="mt-1"
                      :options="filterOptions.gudang"
                      label="name"
                      track-by="code"
                      :multiple="true"
                      placeholder="All Gudang"
                    ></MultiSelect>
                </div>
                <!-- Main Dealer End -->
    
                <!-- Dealer Start -->
                <div v-if="!dealerType" :class="{ 'mobileFilterPaddingTop' : mobile, 'col-md' : !config.dealerTypeExist, 'col-md-4' : config.dealerTypeExist }">
                    <label>Karesidenan</label>
                    <MultiSelect 
                      v-if="filterOptions"
                      v-model="filter.karesidenan"
                      class="mt-1"
                      :options="filterOptions.karesidenan"
                      label="code"
                      track-by="name"
                      :multiple="true"
                      placeholder="All Karesidenan"
                    ></MultiSelect>
                </div>
                <div v-if="!dealerType" :class="{ 'mobileFilterPaddingTop' : mobile, 'col-md' : !config.dealerTypeExist, 'col-md-4' : config.dealerTypeExist }">
                    <label for="partshopCode">City</label>
                    <MultiSelect 
                      v-if="filterOptions"
                      v-model="filter.city"
                      class="mt-1"
                      :options="filterOptions.city"
                      label="code"
                      track-by="name"
                      :multiple="true"
                      placeholder="All Cities"
                    ></MultiSelect>
                </div>
                <div v-if="!dealerType" :class="{ 'mobileFilterPaddingTop' : mobile, 'col-md' : !config.dealerTypeExist, 'col-md-4' : config.dealerTypeExist }">
                    <label for="partshopCode">Dealer</label>
                    <MultiSelect 
                      v-if="filterOptions"
                      v-model="filter.dealer"
                      class="mt-1"
                      :options="filterOptions.dealer"
                      label="name"
                      track-by="code"
                      :multiple="true"
                      placeholder="All Dealer"
                    ></MultiSelect>
                </div>
                <!-- Main Dealer End -->
              </div>
            </div>
            <!-- DEALER/MAIN DEALER FILTER END -->

            <div v-if="config.itemExist" class="col-md-4" style="padding-top:20px">
                <label for="partshopCode">Category</label>
                <MultiSelect 
                  v-if="filterOptions"
                  v-model="filter.category"
                  class="mt-1"
                  :options="filterOptions.category"
                  label="category"
                  track-by="category"
                  :multiple="true"
                  placeholder="All Category"
                ></MultiSelect>
            </div>
            <div v-if="config.itemExist" class="col-md-4" style="padding-top:20px">
                <label for="partshopCode">Segment</label>
                <MultiSelect 
                  v-if="filterOptions"
                  v-model="filter.segment"
                  class="mt-1"
                  :options="filterOptions.segment"
                  label="segment"
                  track-by="segment"
                  :multiple="true"
                  placeholder="All Segment"
                ></MultiSelect>
            </div>
            <div v-if="config.itemExist" class="col-md-4" style="padding-top:20px">
                <label for="partshopCode">Sub Series</label>
                <MultiSelect 
                  v-if="filterOptions"
                  v-model="filter.subSeries"
                  class="mt-1"
                  :options="filterOptions.subSeries"
                  label="subSeries"
                  track-by="subSeries"
                  :multiple="true"
                  placeholder="All Sub Series"
                ></MultiSelect>
            </div>
            <div v-if="config.itemExist" class="col-md-4" style="padding-top:20px">
                <label for="partshopCode">Type</label>
                <MultiSelect 
                  v-if="filterOptions"
                  v-model="filter.type"
                  class="mt-1"
                  :options="filterOptions.type"
                  label="type"
                  track-by="type"
                  :multiple="true"
                  placeholder="All Type"
                ></MultiSelect>
            </div>
            <div v-if="config.itemExist" class="col-md-4" style="padding-top:20px">
                <label for="partshopCode">Code - Market Name</label>
                <MultiSelect 
                  v-if="filterOptions"
                  v-model="filter.codeMarket"
                  class="mt-1"
                  :options="filterOptions.codeMarket"
                  label="name"
                  track-by="codeMarket"
                  :multiple="true"
                  placeholder="All Code Market"
                ></MultiSelect>
            </div>

            <!-- DATE RANGE START -->
            <div v-if="config.dateExist" class="col-md-4" style="padding-top:20px">
              <div class="row">
                <!-- Range Date Start -->
                <div v-if="!config.simpleDate && !config.seperatedRange" class="col-md" style="display:flex; flex-direction: column; justify-content: center;" :class="{ 'mobileFilterPaddingTop' : mobile }">
                  <label for="dateTimeInput">Date Range</label>
                  <flat-pickr
                    v-model="filter.range"
                    :config="rangeConfig"
                    placeholder="Range Picker"
                  />
                </div>
                <div v-if="!config.simpleDate && config.seperatedRange" class="col-md" style="display:flex; flex-direction: column; justify-content: center;" :class="{ 'mobileFilterPaddingTop' : mobile }">
                  <label for="dateTimeInput">From</label>
                  <flat-pickr
                    v-model="filter.start"
                    :config="rangeConfigSeperated"
                    placeholder="Range Picker"
                  />
                </div>
                <div v-if="!config.simpleDate && config.seperatedRange" class="col-md" style="display:flex; flex-direction: column; justify-content: center;" :class="{ 'mobileFilterPaddingTop' : mobile }">
                  <label for="dateTimeInput">To</label>
                  <flat-pickr
                    v-model="filter.end"
                    :config="rangeConfigSeperated"
                    placeholder="Range Picker"
                  />
                </div>
                <!-- Range Date End -->

                <!-- Simple Date Start -->
                <div v-if="config.simpleDate" class="col-md" :class="{ 'mobileFilterPaddingTop' : mobile }">
                    <label for="partshopCode">Month</label>
                    <MultiSelect
                      v-if="filterOptions"
                      class="mt-1"
                      :options="filterOptions.month"
                      label="name"
                      track-by="value"
                      :multiple="false"
                      :allow-empty="false"
                      v-model="filter.month"
                      placeholder="All Months"
                    />
                </div>
                <div v-if="config.simpleDate" class="col-md" :class="{ 'mobileFilterPaddingTop' : mobile }">
                    <label for="partshopCode">Year</label>
                    <MultiSelect
                      v-if="filterOptions"
                      class="mt-1"
                      :options="filterOptions.year"
                      :multiple="false"
                      :allow-empty="false"
                      v-model="filter.year"
                      placeholder="All Years"
                    />
                </div>
                <!-- Simple Date End -->
              </div>
            </div>
            <!-- DATE RANGE END -->
            
            <div class="col-md-4" :class="(config.dateExist) ? 'offset-md-8' : ''" style="display: flex; flex-direction: column-reverse; padding-top:20px">
                <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="submitButton">Search</button>
            </div>
          </div>
      </div>
  </panel>
  <!-- FILTER END -->
</template>

<script>
/* eslint-disable */
  import flatPickr from 'vue-flatpickr-component'
  import Multiselect from 'vue-multiselect'
  import moment from 'moment'

  export default {
    data () {
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
      const endOfMonth   = moment().format('YYYY-MM-DD');
      return {
        filterReady : false,
        mobile : this.isMobile(),
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !isRTL()
        },
        rangeConfigSeperated: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !isRTL() 
        },
        config: {
          dealerTypeExist: false,
          itemExist: true,
          dateExist: true,
          dealerExist: true,
          simpleDate : false,
          seperatedRange: true,
          emptyDate: false,
        },
        dealerType: true,
        // Filter Data and Filter Starts
        filterOptions: {
          mainDealer: [],
          gudang: [],
          karesidenan: [],
          city: [],
          dealer: [],
          category: [],
          segment: [],
          subSeries: [],
          type: [],
          codeMarket: [],
          month : [],
          year : []
        },
        filter: {
          locationType : 'MAINDEALER',
          range: `${startOfMonth} to ${endOfMonth}`,
          start: startOfMonth,
          end: endOfMonth,
          mainDealer: [],
          gudang: [],
          karesidenan: [],
          city: [],
          dealer: [],
          category: [],
          segment: [],
          subSeries: [],
          type: [],
          codeMarket: [],
          month : null,
          year : null
        },
        // Filter Data and Filter Ends
      }
    },
    props : [
      'dealer_filter',//BOOLEAN (true or false) - DEFAULT true - Is dealer_type, main dealer, gudang, karesidenan, dealer show
      'item_filter',//BOOLEAN (true or false) - DEFAULT true - Is item filter of category, segment, subseries, type, and code market shown
      'date_filter',//BOOLEAN (true or false) - DEFAULT true - Is range date or simple date filters shown

      'dealer_type',//STRING (only 'MAIN DEALER' or 'DEALER') Leave empty or null for a switch or both
      'simple_date',//BOOLEAN (true or false) - DEFAULT false - Does it use a simple date (month and year) instead of date range 
      'seperated_range',//BOOLEAN - Default=true - SEPERATED RANGE DATE ('from' and 'to' instead of 'range date')
      'date_empty',//BOOLEAN - Default=false - Empty Default Date (usually 'start' is set on first date of current month and 'end' is set on current date)

      'return_type',//RETURN TYPE ('Object' or 'String') -- string == string for params url
      'fetch_filter'//INTEGER (0, 1, 2, 3) - for update purposes, change value when update is requested
    ],
    components : {
      MultiSelect : Multiselect,
      flatPickr,
    },
    mounted () {
      this.loadFilter()

      //CHECK 'seperated_range'
      if(this.seperated_range != null){
        if (typeof this.seperated_range == 'boolean'){
          this.config.seperatedRange = this.seperated_range;
        } else {
          this.errorPrint("'seperated_range' is a boolean");
        }
      }

      //CHECK 'date_emtpy'
      if(this.date_empty != null){
        if (typeof this.date_empty == 'boolean'){
          if (this.date_empty) {
            this.filter.range = '';
            this.filter.start = '';
            this.filter.end = '';
          }
        } else {
          this.errorPrint("'date_empty' is a boolean");
        }
      }

      //CHECK dealer_filter (dealer or main dealer filter exist)
      if(this.dealer_filter != null && typeof this.dealer_filter == 'boolean'){
        this.config.dealerExist = this.dealer_filter
        if(this.config.dealerExist) delete this.filter.locationType
      }

      //CHECK dealer_type (forced dealer or main dealer filter)
      if(this.dealer_type != null && this.dealer_type != ''){
        if(this.dealer_type.toUpperCase() == 'MAIN DEALER'){
          this.config.dealerTypeExist = true;
          this.dealerType = true;
        } else if(this.dealer_type.toUpperCase() == 'DEALER'){
          this.config.dealerTypeExist = true;
          this.dealerType = false;
        } else if(this.dealer_type == null || this.dealer_type == ''){
          this.config.dealerTypeExist = null;
        } else {
          this.errorPrint("'dealer_type' can only have either 'MAIN DEALER', 'DEALER', or empty string/null")
        }
      }

      //CHECK item_filter (item filter e.g. category, segment, etc exist)
      if(this.item_filter != null && typeof this.item_filter == 'boolean'){
        this.config.itemExist = this.item_filter
      }

      //CHECK date_filter (date filter e.g. range date or simple month year date)
      if(this.date_filter != null && typeof this.date_filter == 'boolean'){
        this.config.dateExist = this.date_filter
        if(!this.date_filter){
          //clear all date filters
          delete this.filter.range;
          delete this.filter.month;
          delete this.filter.year;
        }
      }

      //CHECK simple_date (use month and year instead of date range)
      if(this.simple_date != null && typeof this.simple_date == 'boolean' && this.config.dateExist){
        this.config.simpleDate = this.simple_date

        if(this.config.simpleDate) {
          delete this.filter.range; //clear range in filter as it is not used

          this.filter.month = {
            name : moment().format('MMMM'),
            value : parseInt(moment().format('MM'))
          }
          this.filter.year = moment().format('YYYY')
        } else {
          delete this.filter.month;
          delete this.filter.year;
        }
      }

      this.filterReady = true;
    },
    watch: {
      'fetch_filter' : function() {
        this.submitButton();
      },
      'dealerType' : function() {
        if(this.dealerType){
          this.filter.locationType = 'MAINDEALER'
          this.filter.karesidenan.length = 0;
          this.filter.dealer.length = 0;
          
          //Reset Gudang's Filter Option
          this.loadFilter('mainDealer');
        } else {
          this.filter.locationType = 'DEALER'
          this.filter.mainDealer.length = 0;
          this.filter.gudang.length = 0;

          //Reset Dealer's Filter Option
          this.loadFilter('karesidenan');
        }
      },
      'filter.mainDealer' : function() {
        this.loadFilter('mainDealer')
      },
      'filter.karesidenan' : function() {
        this.loadFilter('karesidenan')
      },
      'filter.city' : function () {
        this.loadFilter('city')
      },
      'filter.category' : function () {
        this.loadFilter('category')
      },
      'filter.segment' : function () {
        this.loadFilter('segment')
      },
      'filter.subSeries' : function () {
        this.loadFilter('subSeries')
      },
      'filter.type' : function () {
        this.loadFilter('type')
      }
    },
    methods : {
      loadFilter(type){
        if (type == 'mainDealer'){
          this.filter.gudang.length = 0;
          this.filterOptions.gudang = this.$store.getters.getGudang(this.filter.mainDealer)
        } else if (type == 'karesidenan'){
          this.filter.city.length = 0;
          this.filterOptions.city = this.$store.getters.getCity(this.filter.karesidenan)
          
          this.filter.dealer.length = 0;
          this.filterOptions.dealer = this.$store.getters.getDealer(this.filter.karesidenan, this.filter.city)
        } else if (type == 'city'){
          this.filter.dealer.length = 0;
          this.filterOptions.dealer = this.$store.getters.getDealer(this.filter.karesidenan, this.filter.city)
        } else if (type == 'category'){
          this.filter.segment.length = 0;
          this.filterOptions.segment = this.$store.getters.getSegment(this.filter.category)

          this.filter.subSeries.length = 0;
          this.filterOptions.subSeries = this.$store.getters.getSubSeries(this.filter.category, this.filter.segment)

          this.filter.type.length = 0;
          this.filterOptions.type = this.$store.getters.getType(this.filter.category, this.filter.segment, this.filter.subSeries)

          this.filter.codeMarket.length = 0;
          this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type)
        } else if (type == 'segment'){
          this.filter.subSeries.length = 0;
          this.filterOptions.subSeries = this.$store.getters.getSubSeries(this.filter.category, this.filter.segment)

          this.filter.type.length = 0;
          this.filterOptions.type = this.$store.getters.getType(this.filter.category, this.filter.segment, this.filter.subSeries)

          this.filter.codeMarket.length = 0;
          this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type)
        } else if (type == 'subSeries'){
          this.filter.type.length = 0;
          this.filterOptions.type = this.$store.getters.getType(this.filter.category, this.filter.segment, this.filter.subSeries)

          this.filter.codeMarket.length = 0;
          this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type)
        } else if (type == 'type'){
          this.filter.codeMarket.length = 0;
          this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type)
        } else {
          this.filterOptions = this.$store.getters.getFilterOptions
        } 
      },
      async pacifiedUrl (filters) {
        let filterUrl = ''
        let keys = Object.keys(filters)
        for (var i = 0; i < keys.length; i++) {
          // if(keys[i] == 'month' || keys[i] == 'year' || keys[i] == 'locationType'){
          //   filterUrl += `${keys[i]}=${filters[keys[i]]}&`
          // } else if (keys[i] == 'range') {
          //   let splitDateRange = filters.range.split(' to ');
          //   filterUrl += 'start=' + splitDateRange[0] + '&'
          //   filterUrl += 'end=' + splitDateRange[1] + '&'
          // } else if(filters[keys[i]].length > 0)
          //   filterUrl += `${keys[i]}=${filters[keys[i]]}&`
          
          if(keys[i] != 'range' && (filters[keys[i]].length > 0 || typeof filters[keys[i]] == 'number')){
            if(!this.config.seperatedRange) continue;
            filterUrl += `${keys[i]}=${filters[keys[i]]}&`
          } else if (!this.config.seperatedRange && keys[i] == 'range') {
            let splitDateRange = filters.range.split(' to ');
            filterUrl += 'start=' + splitDateRange[0] + '&'
            filterUrl += 'end=' + splitDateRange[1] + '&'
          }
        }
        
        return filterUrl.substring(0, filterUrl.length - 1)
      },
      async transformFilter (filter) {
        let obj = {}
        let keys = Object.keys(filter)
        for (var i = 0 ; i < keys.length; i++) {
          if (this.filter[keys[i]] != null && this.filter[keys[i]] != ''){
            if (keys[i] == 'month') {
              obj[keys[i]] = filter[keys[i]].value
            } else if (keys[i] == 'year' || keys [i] == 'range' || keys[i] == 'locationType' || keys [i] == 'start' || keys [i] == 'end') {
              obj[keys[i]] = filter[keys[i]]
            } else {
              obj[keys[i]] = []
              for (var j = 0; j < filter[keys[i]].length; j++) {
                // keys[i] == 'mainDealer' || keys[i] == 'gudang' || keys[i] == 'karesidenan' || keys[i] == 'dealer' ? obj[keys[i]].push(filter[keys[i]][j].code) : keys[i] == 'month' ? obj[keys[i]].push(filter[keys[i]][j].value) : keys[i] == 'year' ? obj[keys[i]].push(filter[keys[i]][j]) : obj[keys[i]].push(filter[keys[i]][j][keys[i]])
                keys[i] == 'mainDealer' || keys[i] == 'gudang' || keys[i] == 'karesidenan' || keys[i] == 'city' || keys[i] == 'dealer' ? obj[keys[i]].push(filter[keys[i]][j].code) : obj[keys[i]].push(filter[keys[i]][j][keys[i]])
              }
            }
          }
        }
        return obj
      },
      async submitButton(){
        this.$emit('onFilter', (this.return_type != null && this.return_type.toLowerCase() == 'object') ? this.filter : await this.pacifiedUrl(await this.transformFilter(this.filter)))
      },
    }
  }

  function isRTL () {
    return document.documentElement.getAttribute('dir') === 'rtl' || document.body.getAttribute('dir') === 'rtl'
  }
</script>

<style>
  .dateCss div input{
    border: 1px solid #e8e8e8;
    border-radius: 5px !important;
    height: 42px;
    margin-top: 3px;
    padding-left: 1% !important;
  }
  .dateCss div input::placeholder{
    padding-left: 1%;
  }
</style>

<style scoped>
  /* Toggle Switch Start */
  .onoffswitch {
      position: relative; width: 130px;
      -webkit-user-select:none; -moz-user-select:none; -ms-user-select: none;
  }

  .onoffswitch-checkbox {
      display: none;
  }

  .onoffswitch-label {
      display: block; overflow: hidden; cursor: pointer;
      border-radius: 20px;
  }

  .onoffswitch-inner {
      display: block; width: 200%; margin-left: -100%;
      -moz-transition: margin 0.3s ease-in 0s; -webkit-transition: margin 0.3s ease-in 0s;
      -o-transition: margin 0.3s ease-in 0s; transition: margin 0.3s ease-in 0s;
  }

  .onoffswitch-inner:before, .onoffswitch-inner:after {
      display: block; float: left; width: 50%; height: 30px; padding: 0; line-height: 30px;
      font-size: 14px; color: white; font-family: Trebuchet, Arial, sans-serif; font-weight: bold;
      -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box;
  }

  .onoffswitch-inner:before {
      content: "Main Dealer";
      padding-left: 10px;
      background-color: #F16F23; color: #FFFFFF;
  }

  .onoffswitch-inner:after {
      content: "Dealer";
      padding-left: 10px;
      background-color: #EEEEEE; color: #999999;
      text-align: center;
  }

  .onoffswitch-switch {
      display: block; width: 18px; margin: 6px;
      background: #FFFFFF;
      border: 2px solid #999999; border-radius: 20px;
      position: absolute; top: 0; bottom: 0; right: 96px;
      -moz-transition: all 0.3s ease-in 0s; -webkit-transition: all 0.3s ease-in 0s;
      -o-transition: all 0.3s ease-in 0s; transition: all 0.3s ease-in 0s; 
  }

  .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
      margin-left: 0;
  }

  .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
      right: 0px; 
  }
/* Toggle Switch End */

  .mobileFilterPaddingTop{
    padding-top: 20px;
  }
</style>
